"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Body = _interopRequireDefault(require("./Body"));

var _Cell = _interopRequireDefault(require("./Cell"));

var _Head = _interopRequireDefault(require("./Head"));

var _Row = _interopRequireDefault(require("./Row"));

var _excluded = ["bodyVerticalAlignment", "borderedColumns", "borderless", "children", "className", "headVerticalAlignment", "headingNoWrap", "hover", "noWrap", "responsive", "responsiveSize", "striped", "tableVerticalAlignment"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ClayTable = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classNames2;

  var bodyVerticalAlignment = _ref.bodyVerticalAlignment,
      borderedColumns = _ref.borderedColumns,
      borderless = _ref.borderless,
      children = _ref.children,
      className = _ref.className,
      headVerticalAlignment = _ref.headVerticalAlignment,
      headingNoWrap = _ref.headingNoWrap,
      _ref$hover = _ref.hover,
      hover = _ref$hover === void 0 ? true : _ref$hover,
      noWrap = _ref.noWrap,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? true : _ref$responsive,
      responsiveSize = _ref.responsiveSize,
      striped = _ref.striped,
      tableVerticalAlignment = _ref.tableVerticalAlignment,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_defineProperty({
      'table-responsive': responsive
    }, "table-responsive-".concat(responsiveSize), responsiveSize)),
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("table", _extends({
    className: (0, _classnames.default)('table table-autofit', (_classNames2 = {
      'show-quick-actions-on-hover': hover,
      'table-bordered': borderedColumns,
      'table-heading-nowrap': headingNoWrap,
      'table-hover': hover,
      'table-list': !borderless,
      'table-nowrap': noWrap,
      'table-striped': striped
    }, _defineProperty(_classNames2, "tbody-valign-".concat(bodyVerticalAlignment), bodyVerticalAlignment), _defineProperty(_classNames2, "thead-valign-".concat(headVerticalAlignment), headVerticalAlignment), _defineProperty(_classNames2, "table-valign-".concat(tableVerticalAlignment), tableVerticalAlignment), _classNames2), className)
  }, otherProps), children));
});

ClayTable.displayName = 'ClayTable';

var _default = Object.assign(ClayTable, {
  Body: _Body.default,
  Cell: _Cell.default,
  Head: _Head.default,
  Row: _Row.default
});

exports.default = _default;